import createDOMPurify from 'dompurify';

const DOMPurify = createDOMPurify(global.window);

export default DOMPurify;
export const sanitize = DOMPurify.sanitize;
